import DataMapper from './DataMapper'

import LodgingExpenses from '../../models/LodgingExpenses'
import LodgingExpensesRM from '../responsemodel/LodgingExpensesRM'

export default class LodgingExpensesDataMapper extends DataMapper<LodgingExpensesRM, LodgingExpenses> {
    map = (rm: LodgingExpensesRM) => {
        return new LodgingExpenses(
            rm._id,
            rm.investigator_id,
            rm.request_coordinates,
            rm.request_address,
            rm.request_status,
            rm.request_date,
            rm.request_rejection_reason,
            rm.request_action_taken_by,
            rm.lodging_amount,
            rm.lodging_amount_status,
            rm.amount_action_taken_by,
            rm.lodging_receipts,
            rm.lodging_receipts_status,
            rm.receipt_action_taken_by,
            rm.payment_status,
            rm.payment_date,
            rm.utr_number
        )
    }
}
